import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	easyCommandsPlaceholder: {
		id: 'editor-presets-hub.placeholder.easy-commands-placeholder',
		defaultMessage: 'Type / for all elements.',
		description: 'The placeholder for the editor to help discover the slash command',
	},
	aiPlaceholder: {
		id: 'editor-presets-hub.placeholder.ai-placeholder',
		defaultMessage: 'Type /ai for Atlassian Intelligence or / to add elements.',
		description:
			'The placeholder for the editor to help discover our text generative AI, Atlassian Intelligence.',
	},
	defaultPlaceholder: {
		id: 'editor-presets-hub.placeholder.default-placeholder',
		defaultMessage: 'Type / to insert elements',
		description: 'The placeholder shown in empty document to help discover slash command',
	},
	editorEmptyDocumentPlaceholderAI: {
		id: 'editor-presets-hub.placeholder.default-placeholder-ai',
		defaultMessage: "Use {key}+' to ask AI, or type / to insert elements",
		description: 'The placeholder shown in empty document to help discover ai and slash command',
	},
});
